import * as React from 'react';
import { FieldProps } from '../metadataFormField';
import { getMetadata, getSchema } from '../../../utils';
import { NodeType } from '../../../enums/NodeType';
import { Metadata, Schema } from '../../../types/Metadata';
import { FieldType } from '../../../enums/FieldType';
import './impliedData.scss';
import { Pill } from '../../Pill/pill';
import { useImpliedDataConfirmModal } from '../../ConfirmModal/confirmModal';
import { ActionMenu } from '../../ActionMenu/actionMenu';

const NO_IMPLIED_NODES = [NodeType.Employee, NodeType.Status, NodeType.Item];

export const ImpliedData = ({
  field,
  data,
  schemas,
  disabled,
  updater
}: FieldProps & { schemas: Schema[] }) => {
  if (disabled) return null;

  const nodeType = field.dataType as NodeType;
  if (field.fieldType != FieldType.reference) return null;
  if (!nodeType || NO_IMPLIED_NODES.includes(nodeType)) return null;

  const metadata = getMetadata(data.metadata, nodeType);
  if (!metadata?.length) return null;

  const schema = getSchema(schemas, nodeType);
  const df = schema?.props?.displayField;

  const { confirm, ConfirmModal } = useImpliedDataConfirmModal();
  const accept = (ms: Metadata[]) => {
    updater.updateField(field, ms);
    updater.updateData(field, ms);
  };

  return (
    <>
      {metadata.map(m => (
        <div className="implied-data" key={m.id}>
          <div>
            <Pill name={m.props[df]} />
            <Pill className="pill-implied" name="Implied" />
          </div>
          {!field.multiValue && (
            <ActionMenu
              accept={({ setLoading }) => {
                let value: Metadata[] = [];
                if (data?.props) {
                  value = data.props[field.field];
                }
                if (value?.length) {
                  confirm({
                    onConfirm: () => {
                      setLoading(true);
                      accept([m]);
                    },
                    onCancel: () => setLoading(false)
                  });
                } else {
                  setLoading(true);
                  accept([m]);
                }
              }}
            />
          )}
        </div>
      ))}
      <ConfirmModal />
    </>
  );
};
